import React, { useState } from "react";
import { useForm } from "react-hook-form";
import authHeader from "services/auth-header";
import API from "services/axios";

function PermissionsUpdate({ data, showUpdatePage, refreshFunc }) {
  /*   All States Below
   ********************************************* */
  const { register, handleSubmit } = useForm();
  const [formError, setFormError] = useState({});

  /*   All Functions Below
   ********************************************* */
  const updatePermissionsData = async (formData, e) => {
    setFormError({});
    e.preventDefault();
    if (formData.permGroup === "") {
      setFormError({
        permGroup: { type: "permGroup", message: "Group is required" },
      });
      return;
    }
    if (formData.permName === "") {
      setFormError({
        permName: { type: "permName", message: "Perm Name is required" },
      });
      return;
    }
    if (formData.permDescription === "") {
      setFormError({
        permDescription: {
          type: "permDescription",
          message: "Perm Description is required",
        },
      });
      return;
    }
    try {
      const resp = await API.patch(
        "/permissions/",
        { data: { ...formData, id: data.id } },
        { headers: authHeader() }
      );

      if (resp.data.message.type === "success") {
        refreshFunc();
        showUpdatePage(false);
        return;
      }
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        {/*    Update FORM START
         ********************************************* */}
        {data && (
          <form
            className="ps-3 pe-3"
            onSubmit={handleSubmit(updatePermissionsData)}
          >
            <div className="mb-3">
              <h3>UPDATE {data?.term_name?.toUpperCase()}</h3>
            </div>
            {/* ----------  Fields  ----------- */}
            <div className="mt-3 mb-3">
              <label htmlFor="permMainModule" className="form-label">
                Main Module Name
              </label>
              <input
                className="form-control"
                type="text"
                id="permMainModule"
                required
                placeholder="Enter Main Module Name"
                defaultValue={data?.permMainModule || ""}
                {...register("permMainModule")}
              />
            </div>
            <div className="mt-3 mb-3">
              <label htmlFor="permGroup" className="form-label">
                Group Name
              </label>
              <input
                className="form-control"
                type="text"
                id="permGroup"
                required
                defaultValue={data?.permGroup || ""}
                placeholder="Enter name"
                {...register("permGroup")}
              />
              {formError && formError.permGroup && (
                <p className="text-danger">{formError.permGroup.message}</p>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="permName" className="form-label">
                Perm Name
              </label>
              <input
                className="form-control"
                type="permName"
                required
                id="permName"
                placeholder="Enter perm name"
                defaultValue={data?.permName || ""}
                {...register("permName")}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="permDescription" className="form-label">
                Perm Description
              </label>
              <input
                className="form-control"
                type="permDescription"
                required
                id="permDescription"
                placeholder="Enter perm description"
                defaultValue={data?.permDescription || ""}
                {...register("permDescription")}
              />
            </div>

            <div className={`mt-4 mb-2 d-flex justify-content-end`}>
              <div>
                <button
                  className="btn px-1 btn-secondary"
                  type="button"
                  onClick={() => {
                    showUpdatePage(false);
                  }}
                >
                  Cancel
                </button>
                <button className="btn btn-primary ms-1" type="submit">
                  UPDATE
                </button>
              </div>
            </div>
          </form>
        )}
        {/*    Update FORM END
         ********************************************* */}
      </div>
    </div>
  );
}

export default PermissionsUpdate;
